import Axios from './caller.service';
import { accountService } from './account.service';


const getAllUsers = async () => {
    try {
        const token = accountService.getToken();
        const response = await Axios.get('api/v1/contacts', {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération de la liste des utilisateurs :', error);
        throw error;
    }
};

const createContact = async (formfields) => {
    try {
        const token = accountService.getToken();
        const response = await Axios.post('api/v1/contacts', formfields, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        return response;
        
    } catch (error) {
        console.error("Erreur lors de la creation d'un contact:", error);
        throw error;
    }
};


const getUserById = async (userid) => {
    try {
        const token = accountService.getToken();
        const response = await Axios.get(`api/v1/contacts/${userid}`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération de l'utilisateur avec l'ID ${userid} :`, error);
        throw error;
    }
};

const deleteContactById = async (userid) => {
    try {
        const token = accountService.getToken();
        const response = await Axios.delete(`api/v1/contacts/${userid}`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        })
        return response.data;
    } catch (error) {
      console.error(`Erreur lors de la suppression de l'utilisateur avec l'ID ${userid} :`, error);
      throw error;
    }
};

const updateContactById = async (userid, updatedFields) => {
    try {
      const token = accountService.getToken();
      const response = await Axios.put(`api/v1/contacts/${userid}`, updatedFields, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
  
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la mise à jour de l'utilisateur avec l'ID ${userid} :`, error);
      throw error;
    }
  };


export const userService = {
    getAllUsers,
    getUserById,
    updateContactById,
    createContact,
    deleteContactById,
};
